import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'kt-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ToggleComponent), multi: true }]
})
export class ToggleComponent implements ControlValueAccessor {
  @Input() label = '';
  @Input() labelPosition: 'before' | 'after' = 'after';
  @Input() disabled = false;
  @Input() hint = '';
  @Input() onLabel = '';
  @Input() offLabel = '';
  @Input() color: 'primary' | 'accent' | 'warn' = 'primary';

  value = false;

  onChange = (_: any) => { };
  onTouched = () => { };

  get statusLabel(): string {
    return this.value ? (this.onLabel || '') : (this.offLabel || '');
  }

  onToggleChange(checked: boolean) {
    this.value = checked;
    this.onChange(this.value);
    this.onTouched();
  }

  writeValue(value: any) { this.value = !!value; }
  registerOnChange(fn: any) { this.onChange = fn; }
  registerOnTouched(fn: any) { this.onTouched = fn; }
  setDisabledState(isDisabled: boolean) { this.disabled = isDisabled; }
}
